import { ApiUrls } from "./api-urls";
import { ApplicationService, HttpService } from "./application.service"

export const ProjectRequestService = {
    create: () => {
        return ApplicationService.post<any>(ApiUrls.PROJECT_REQUEST_POST, {});
    },
    getData: () => {
        return ApplicationService.get<any>(ApiUrls.PROJECT_REQUEST_GET);
    },
    decline: (id: number) => {
        return ApplicationService.delete<any>(ApiUrls.PROJECT_REQUEST_DELETE(id));
    }
}